import React from 'react'
import { WizardContext } from 'react-albus'
import { useFormik, FormikProvider } from 'formik'

import { Divider, Action } from 'components'

import { useSignup } from '../../store'
import { brokerSchema } from '../../schema'
import { Company } from './Company'
import { Responsible } from './Responsible'

const initialValues = {
  document: '',
  name: '',
  susep: '',
  email: '',
  responsible: {
    name: '',
    email: '',
    cpf: '',
    phone: '',
  },
}

export type BrokerValues = typeof initialValues

export type BrokerProps = {
  wizard: WizardContext
}

export const Broker = ({ wizard }: BrokerProps) => {
  const { getValues, setValues } = useSignup()

  const form = useFormik<BrokerValues>({
    initialValues: getValues('broker') || initialValues,
    validationSchema: brokerSchema,
    onSubmit: (values) => {
      setValues('broker', values)
      wizard.next()
    },
  })

  return (
    <FormikProvider value={form}>
      <form onSubmit={form.handleSubmit}>
        <Company />
        <Divider title="Pessoa Física com poderes para assinar pela Corretora de Seguros" />
        <Responsible />

        <Action
          back={{
            label: 'Cancelar',
            to: '/',
          }}
          next="Dados do estipulante"
        />
      </form>
    </FormikProvider>
  )
}
